import * as React from 'react';
import { ReactComponent as DocPaperIconSVG } from '../../assets/icons/mevo/ic-multiple-doc-paper.svg';
import IconPattern, { IconProps } from './_IconPattern';

const DocPaperMultipleIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={DocPaperIconSVG} variantPlaces={2} {...props} />;
};

export default DocPaperMultipleIcon;
